<div class="no-scroll">
  <mat-card-content>
    <mat-card>
      <mat-progress-bar color="primary" mode="indeterminate" [hidden]="!isLoading"></mat-progress-bar>

      <mat-card-header class="header-padrao">
        <mat-card-title>Itens Inventariados</mat-card-title>
        <mat-card-title>
          <h5 class="subTitle">Total NRT:{{ totalNRT }} - Total Volume:{{ totalVolume }}</h5>
        </mat-card-title>
      </mat-card-header>

      <mat-card-content class="apontamento-filtros">
        <div id="scrollable-table">
          <table #table id="communication-table" mat-table [dataSource]="colletion">
            <ng-container matColumnDef="contador">
              <th mat-header-cell *matHeaderCellDef class="text-center contador">
                #
              </th>
              <td mat-cell *matCellDef="let item" class="text-center contador">
                {{ item.contador }}
              </td>
            </ng-container>

            <ng-container matColumnDef="data">
              <th mat-header-cell *matHeaderCellDef class="text-center">
                Data
              </th>
              <td mat-cell *matCellDef="let item" class="text-center">
                {{ item.data | date: 'dd/MM/yyyy HH:mm:ss' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="inventariante">
              <th mat-header-cell *matHeaderCellDef class="text-center">
                Inventariante
              </th>
              <td mat-cell *matCellDef="let item" class="text-center">
                {{ item.inventariante }}
              </td>
            </ng-container>

            <ng-container matColumnDef="NRT">
              <th mat-header-cell *matHeaderCellDef class="text-center">NRT</th>
              <td mat-cell *matCellDef="let item" class="text-center">
                {{ item.nrt }}
              </td>
            </ng-container>

            <ng-container matColumnDef="barcode">
              <th mat-header-cell *matHeaderCellDef class="text-center">Cód. Volume</th>
              <td mat-cell *matCellDef="let item" class="text-center">
                {{ item.barcode }}</td>
            </ng-container>

            <ng-container matColumnDef="etiqueta">
              <th mat-header-cell *matHeaderCellDef class="text-center">Etiqueta</th>
              <td mat-cell *matCellDef="let item" class="text-center">
                {{ item.etiqueta }}</td>
            </ng-container>


            <ng-container matColumnDef="documento">
              <th mat-header-cell *matHeaderCellDef class="text-center">
                Documento
              </th>
              <td mat-cell *matCellDef="let item" class="text-center">
                {{ item.documento }}
              </td>
            </ng-container>

            <ng-container matColumnDef="cliente">
              <th mat-header-cell *matHeaderCellDef class="text-center">
                Cliente
              </th>
              <td mat-cell *matCellDef="let item" class="text-center">
                {{ item.cliente }}
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef class="text-center">
                Status
              </th>
              <td mat-cell *matCellDef="let item" class="text-center">
                {{ item.status }}
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
          <div *ngIf="!isLoading && colletion?.data?.length === 0"
            class="d-flex justify-content-center align-items-center" style="height: 100px">
            Nenhum registro foi encontrado!
          </div>
          <app-paginacao #paginator [pageIndex]="paging?.index" [pageSize]="paging?.size" [length]="paging?.length"
            (page)="onPageChange($event)" [pageSizeOptions]="[5, 10, 15]">
          </app-paginacao>
        </div>
      </mat-card-content>
    </mat-card>
  </mat-card-content>
</div>
